export default {
  setProdutoForca(state, payload) {
    state.produto = payload
  }
}
